// @owners { team: patients-team }
import { ActionSheetContext } from '@alto/design-system';
import React, { useCallback, useContext } from 'react';
import { ContactInfoActionSheet } from './ContactInfoActionSheet';
import { ReauthRequired } from '~web/features/auth/components/ReauthRequired';

export const ContactInfoWithAuth = () => {
  const { overrideActionSheetStack } = useContext(ActionSheetContext);

  const onReauth = useCallback(() => {
    overrideActionSheetStack([<ContactInfoActionSheet key="contact-info" />]);
  }, [overrideActionSheetStack]);

  return <ReauthRequired onReauth={onReauth} />;
};
